import { CalendarIcon, CurecallTooltip, CurecallButton, ECurecallSize } from '@honestica/curecall-ui'
import { useParams } from 'react-router'
import type { TDashboardPatientOverview } from '../dashboard.type'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from 'src/components/navigation/localized-link.component'
import { PatientPhone } from 'src/components/patient/patient-phone.component'
import PatientGenderIcon from 'src/components/patient/patient-gender-icon.component'
import { getPatientCivilityAndFullName } from 'src/utils/string-formatter.util'
import { useModals } from 'src/providers/modals.provider'
import { WithPermission } from 'src/providers/current-project.provider'
import {
  EPermissionGrantActions,
  EPermissionGrantSubjects,
} from 'src/pages/configuration/permissions/_components/permissions.type'

const PatientMedEventOverviewPatientDetails = ({
  dashboardPatientOverview,
}: {
  dashboardPatientOverview: TDashboardPatientOverview
}) => {
  const { openFollowupModal } = useModals()
  const { projectId } = useParams()
  const { t } = useTranslation()

  const currentPatientFollowupId = dashboardPatientOverview.patientMedEvent.PatientFollowup.id

  return (
    <>
      <section className="c-font-bold c-text-primary c-flex c-items-center c-gap-2 c-max-w-max">
        <div className="c-flex c-items-center c-gap-2">
          <PatientGenderIcon patient={dashboardPatientOverview.patient} />
          <CurecallTooltip
            content={t('components.patient-med-event-overview.patient-details')}
            tooltipPosition="bottom-start"
          >
            <h2 className="c-text-xl c-p-0 c-m-0 c-mt-1 c-cursor-pointer">
              <LocalizedLink
                to={`/${projectId}/medical/patients/${dashboardPatientOverview.patient.id}/${currentPatientFollowupId}`}
              >
                {getPatientCivilityAndFullName(t, dashboardPatientOverview.patient)}
              </LocalizedLink>
            </h2>
          </CurecallTooltip>
        </div>
        <WithPermission
          requiredSubject={EPermissionGrantSubjects.PATIENT}
          requiredAction={EPermissionGrantActions.UPDATE}
        >
          <CurecallTooltip
            content={t('components.patient-med-event-overview.followup-medevents')}
            tooltipPosition="bottom-end"
            isPinOnClickEnabled={false}
          >
            <CurecallButton
              ariaLabelText={t('components.patient-med-event-overview.followup-medevents')}
              iconType={<CalendarIcon />}
              isGhostButton
              onClick={() =>
                openFollowupModal({
                  patientId: dashboardPatientOverview.patient.id,
                  patientFollowupIdToEdit: dashboardPatientOverview.patientMedEvent.PatientFollowup.id,
                })
              }
              size={ECurecallSize.LARGE}
            />
          </CurecallTooltip>
        </WithPermission>
      </section>

      <div className="c-flex c-items-center c-text-sm c-gap-2">
        <PatientPhone patient={dashboardPatientOverview.patient} showCopyButton={true} />
      </div>
    </>
  )
}

export default PatientMedEventOverviewPatientDetails
